/* eslint-disable react/self-closing-comp */
import React, { useState } from 'react';
import {
  IconButton,
  Tooltip,
  Popover,
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';
import 'flag-icons/css/flag-icons.min.css';

function HeaderLanguage() {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const languages = [
    { code: 'en', label: 'English', flag: 'fi fi-gb' },
    { code: 'fr', label: 'Français', flag: 'fi fi-fr' },
    { code: 'dt', label: 'Deutsch', flag: 'fi fi-de' },
    { code: 'es', label: 'Español', flag: 'fi fi-es' },
    { code: 'ar', label: 'العربية', flag: 'fi fi-sa' },
    { code: 'pt', label: 'Português', flag: 'fi fi-pt' }
  ];

  // Check if current language is RTL
  const isRTL = i18n.language === 'ar';

  return (
    <>
      <Tooltip title={t('Language') || 'Language'} arrow>
        <IconButton
          onClick={handleOpen}
          sx={{
            p: 0,
            width: 40,
            height: 40,
            borderRadius: '10px',
            backgroundColor: 'transparent',
            border: '1px solid transparent',
            transition: 'all 0.25s ease',
            '&:hover': {
              backgroundColor: 'rgba(24,230,142,0.1)',
              transform: 'scale(1.05)'
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& svg': {
              fontSize: 24,
              color: '#18E68E'
            }
          }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: {
            p: 1,
            borderRadius: 2,
            minWidth: 160,
            backgroundColor: '#1e1f22'
          }
        }}
      >
        <List dense>
          {languages.map((lang) => (
            <ListItemButton
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              selected={i18n.language === lang.code}
              sx={{
                borderRadius: 1,
                '&.Mui-selected': {
                  backgroundColor: 'rgba(24,230,142,0.15)',
                  '&:hover': { backgroundColor: 'rgba(24,230,142,0.25)' }
                }
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  width: '100%',
                  // Reverse order in RTL: flag goes to the right
                  flexDirection: isRTL ? 'row-reverse' : 'row'
                }}
              >
                <span className={lang.flag} style={{ fontSize: 20 }}></span>
                <ListItemText
                  primary={
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                      {lang.label}
                    </Typography>
                  }
                />
              </Box>
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </>
  );
}

export default HeaderLanguage;
